(() => {
  'use strict';
  function init(root = document) {
    root.querySelectorAll('[data-pg-products]').forEach(section => {
      if (section.dataset.pgReady) return;
      section.dataset.pgReady = 'true';
      const filters = section.querySelectorAll('[data-pg-filter]');
      const cards = section.querySelectorAll('[data-pg-phase]');
      filters.forEach(button => button.addEventListener('click', () => {
        filters.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        let count = 0;
        cards.forEach(card => {
          card.hidden = button.dataset.pgFilter !== 'all' && card.dataset.pgPhase !== button.dataset.pgFilter;
          if (!card.hidden) count++;
        });
        section.querySelector('[data-pg-empty]').hidden = count > 0;
        section.querySelector('[data-pg-filter-status]').textContent = `${count} Produkte in der Auswahl ${button.textContent.trim()}.`;
      }));
    });
    root.querySelectorAll('[data-pg-header]').forEach(header => {
      if (header.dataset.pgReady) return;
      header.dataset.pgReady = 'true';
      const updateHeight = () => document.documentElement.style.setProperty('--header-height', `${Math.round(header.getBoundingClientRect().height)}px`);
      updateHeight();
      if ('ResizeObserver' in window) {
        header._pgResizeObserver = new ResizeObserver(updateHeight);
        header._pgResizeObserver.observe(header);
      }
      header.querySelectorAll('details').forEach(detail => detail.addEventListener('toggle', () => {
        if (!detail.open) return;
        header.querySelectorAll('details[open]').forEach(other => {
          if (other !== detail && !other.contains(detail) && !detail.contains(other)) other.open = false;
        });
        if (detail.matches('[data-pg-search]')) detail.querySelector('input').focus();
      }));
    });
    root.querySelectorAll('[data-pg-sticky-buy]').forEach(bar => {
      if (bar.dataset.pgReady) return;
      bar.dataset.pgReady = 'true';
      const sectionId = bar.dataset.pgStickyBuy;
      const product = document.getElementById(`MainProduct-${sectionId}`);
      if (!product) return;
      const trigger = bar.querySelector('[data-pg-sticky-submit]');
      const originalButton = () => product.querySelector('[id^="ProductSubmitButton-"]');
      const update = () => {
        const button = originalButton();
        if (!button) { bar.hidden = true; return; }
        trigger.disabled = button.disabled || button.getAttribute('aria-disabled') === 'true';
        trigger.textContent = button.querySelector('span')?.textContent.trim() || button.textContent.trim();
        const price = product.querySelector('.price__sale .price-item--sale');
        const regularPrice = product.querySelector('.price__regular .price-item--regular');
        const onSale = product.querySelector('.price--on-sale');
        bar.querySelector('[data-pg-sticky-price]').textContent = ((onSale ? price : regularPrice)?.textContent || '').trim();
      };
      trigger.addEventListener('click', () => {
        const button = originalButton();
        if (button && !button.disabled) button.click();
      });
      update();
      const mutation = new MutationObserver(update);
      mutation.observe(product, {subtree: true, childList: true, attributes: true, attributeFilter: ['disabled','aria-disabled','class']});
      bar._pgMutation = mutation;
      if ('IntersectionObserver' in window && originalButton()) {
        const observer = new IntersectionObserver(entries => {
          const entry = entries[0];
          bar.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
          document.body.classList.toggle('pg-has-sticky', !bar.hidden && matchMedia('(max-width:749px)').matches);
        }, {threshold: 0});
        observer.observe(originalButton());
        bar._pgIntersection = observer;
      }
    });
  }
  document.addEventListener('click', event => {
    document.querySelectorAll('[data-pg-header] details[open]').forEach(detail => {
      if (!detail.contains(event.target)) detail.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const openDetails = [...document.querySelectorAll('[data-pg-header] details[open]')];
    const detail = openDetails.reverse().find(node => node.contains(document.activeElement)) || openDetails[0];
    if (detail) { detail.open = false; detail.querySelector('summary').focus(); }
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-pg-header],[data-pg-sticky-buy]').forEach(node => {
      node._pgResizeObserver?.disconnect(); node._pgMutation?.disconnect(); node._pgIntersection?.disconnect();
    });
    if (event.target.querySelector('[data-pg-sticky-buy]')) document.body.classList.remove('pg-has-sticky');
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
})();
